// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__pxfKa","info":"PatientInfo_info__1G6yn"};